import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import getConfig from '../../../helpers/config';
import { PaginationReturn } from '../../../interfaces/pagination';
import {
  TrainingAttendance,
  TrainingAttendanceForParticipantProps,
  TrainingAttendanceQueryProp,
  TrainingAttendanceQueryProps,
  TrainingAttendanceRequest,
  TrainingAttendanceResponse,
} from '../../../interfaces/training';
import { getPrepareHeaders } from '../get-prepare-headers';
const { test } = getConfig();

export const trajnimPrezencaApi = createApi({
  reducerPath: 'trajnimPrezencaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['Prezenca'],
  endpoints: builder => ({
    getAllTrainingsAttendance: builder.query<
      PaginationReturn<TrainingAttendance>,
      TrainingAttendanceQueryProps
    >({
      query: args =>
        getCommonUrl(args, 'trajnim-prezenca', 'trajnimDataFillimit'),
      providesTags: ['Prezenca'],
    }),
    getTrainingAttendanceById: builder.query<
      TrainingAttendanceResponse,
      TrainingAttendanceRequest
    >({
      query: args => getCommonUrl(args, `trajnimi/${args?.id}/prezenca`),
      providesTags: ['Prezenca'],
    }),
    getTrainingAttendanceForExpert: builder.query<
      TrainingAttendanceResponse,
      TrainingAttendanceRequest
    >({
      query: args =>
        getCommonUrl(args, `trajnimi/${args.id}/prezenca/per-ekspert`),
    }),
    updateTrainingAttendance: builder.mutation<
      void,
      TrainingAttendanceQueryProp
    >({
      query: args => {
        return {
          url: `/trajnim-prezenca/${args.idTrajnimPrezenca}?ditePrezent=${args.ditePrezent}`,
          method: 'PUT',
        };
      },
      invalidatesTags: ['Prezenca'],
    }),
    getTrainingAttendanceForParticipant: builder.query<
      PaginationReturn<TrainingAttendanceForParticipantProps>,
      TrainingAttendanceQueryProps
    >({
      query: args => getCommonUrl(args, 'trajnim-prezenca/per-pjesemarres'),
    }),
  }),
});

export const {
  useGetAllTrainingsAttendanceQuery,
  useGetTrainingAttendanceByIdQuery,
  useGetTrainingAttendanceForExpertQuery,
  useUpdateTrainingAttendanceMutation,
  useGetTrainingAttendanceForParticipantQuery,
} = trajnimPrezencaApi;
